enum TechnicalConsultantGoiania {
  VITORIA_ARAUJO = "Vitória Araújo Da Silveira Magalhães",
  // JHESSICA_GABRIELLA = "Jhessica Gabriella Pereira",
  FRANCISCA_MARTINS = "Francisca Martins Rodrigues",
  INGRID_VITORIA = "Ingrid Vitória De Araújo Lins"
}

enum TechnicalConsultantBrasilia {
  MIRELLY_PINHO = "Mirelly Pinho Sousa",
  RENATA_RIBEIRO = "Renata Ribeiro Alves",
}

enum TechnicalConsultantCampoGrande {
  NAIARA_SLONGO = "Naiara Slongo Da Silva",
  LETICIA_MARTINS_AGUERO = "Leticia Martins Aguero",
  MAYRO_DOUGLAS_CACERES = "Mayro Douglas Caceres",
}

// enum TechnicalConsultantSenadorCanedo {
//   JHESSICA_GABRIELLA = "Jhessica Gabriella Pereira",
// }

enum TechnicalConsultantAnapolis {
  ISADORA_SANTOS = "Isadora dos Santos Landim",
}
enum TechnicalConsultantCuiaba {
  MARIA_LYGIA = "Maria Lygia Pereira De Souza",
  // GILMARA_LEITE = "Gilmara Leite Cândido"
}

enum TechnicalConsultantTeresina {
  ROBERTA_DOS_SANTOS = "Roberta Dos Santos Ferreira",
  STHEFANY_AZEVEDO = "Sthefany Azevedo Martins",
}

enum TechnicalConsultantRioVerde {
  ALCIENE_MARTINS = "Andressa Aparecida Dos Santos",
}

enum TechnicalConsultantRecife {
  ISADORA_BORGES = "Isadora Borges Venancio",
}

enum TechnicalConsultantPlus {
  LORENNA_FIDELIS = "Lorenna Fidelis De Matos Silva",
  FRANCISCO_DOUGLAS_EUCLIDES = "Francisco Douglas Euclides Carvalho",
  YAN_GUSTAVO = "Yan Gustavo Maia Alencar",
  ALINY_GUIMARAES = "Aliny Guimarães Xavier",
  ISABELA_ALVES = "Isabela Alves de Oliveira",
}

enum TechnicalConsultantSaoLuis {
  STHEFANY_AZEVEDO = "Sthefany Azevedo Martins",
}

enum TechnicalConsultantCampinas {
  PAULA_ISABELA = "Paula Isabela Maria Da Silva",
}
enum TechnicalConsultantUNID_MOVEL {
  LUCAS_GABRIEL = "Lucas Gabriel Arantes Batista",
  PAULO_HENRIQUE = "Paulo Henrique de Moura",
}

enum TechnicalConsultantUberlandia {
  JULIANA_CHRISTINA = "Juliana Christina Oliveira Dos Reis",
}

enum TechnicalConsultantAguasLindas {
  CLEONICE_ALVES = "Cleonice Alves Rodrigues",
}

// Defina o tipo para as opções de consultores
interface ConsultantOption {
  value: string;
  label: string;
}

export const getConsultantOptions = (
  companyName?: string,
  savedValue?: string
): ConsultantOption[] => {
  const baseOptions: ConsultantOption[] = [
    { value: "", label: "-" }, // Adiciona a opção vazia no início
  ];

  let specificOptions: ConsultantOption[] = [];

  // Se companyName não for fornecido ou for vazio, retorna todos os consultores
  if (!companyName) {
    // Combina todos os consultores de todos os enums
    const allConsultants = [
      ...Object.values(TechnicalConsultantGoiania),
      ...Object.values(TechnicalConsultantBrasilia),
      ...Object.values(TechnicalConsultantCampoGrande),
      // ...Object.values(TechnicalConsultantSenadorCanedo),
      ...Object.values(TechnicalConsultantAnapolis),
      ...Object.values(TechnicalConsultantCuiaba),
      ...Object.values(TechnicalConsultantTeresina),
      ...Object.values(TechnicalConsultantRioVerde),
      ...Object.values(TechnicalConsultantRecife),
      ...Object.values(TechnicalConsultantSaoLuis),
      ...Object.values(TechnicalConsultantUNID_MOVEL),
      ...Object.values(TechnicalConsultantCampinas),
      ...Object.values(TechnicalConsultantUberlandia),
      ...Object.values(TechnicalConsultantAguasLindas),
    ];

    // Remove duplicatas usando Set
    const uniqueConsultants = [...new Set(allConsultants)];

    // Ordena alfabeticamente
    uniqueConsultants.sort();

    specificOptions = uniqueConsultants.map((value) => ({
      value,
      label: value,
    }));
  } else {
    switch (companyName) {
      case "BRASILIA/DF":
        specificOptions = Object.values(TechnicalConsultantBrasilia).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "GOIANIA/GO":
        specificOptions = Object.values(TechnicalConsultantGoiania).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "CAMPO GRANDE/MS":
        specificOptions = Object.values(TechnicalConsultantCampoGrande).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      // case "SENADOR CANEDO/GO":
      //   specificOptions = Object.values(TechnicalConsultantSenadorCanedo).map(
      //     (value) => ({
      //       value,
      //       label: value,
      //     })
      //   );
      //   break;
      case "ANAPOLIS/GO":
        specificOptions = Object.values(TechnicalConsultantAnapolis).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "CUIABA/MT":
        specificOptions = Object.values(TechnicalConsultantCuiaba).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "TERESINA/PI":
        specificOptions = Object.values(TechnicalConsultantTeresina).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "RIO VERDE/GO":
        specificOptions = Object.values(TechnicalConsultantRioVerde).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "VALPARAISO DE GOIAS/DF":
        specificOptions = Object.values(TechnicalConsultantBrasilia).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "RECIFE/PE":
        specificOptions = Object.values(TechnicalConsultantRecife).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "SAO LUIS/MA":
        specificOptions = Object.values(TechnicalConsultantSaoLuis).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "CAMPINAS/SP":
        specificOptions = Object.values(TechnicalConsultantCampinas).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "UNID. MOVÉL/GO":
        specificOptions = Object.values(TechnicalConsultantUNID_MOVEL).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "UBERLANDIA/MG":
        specificOptions = Object.values(TechnicalConsultantUberlandia).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      case "ÁGUAS LINDAS/DF":
        specificOptions = Object.values(TechnicalConsultantAguasLindas).map(
          (value) => ({
            value,
            label: value,
          })
        );
        break;
      default:
        specificOptions = [];
        break;
    }
  }

  // Adiciona o valor salvo às opções, caso não esteja presente nas opções específicas
  if (
    savedValue &&
    !specificOptions.some((option) => option.value === savedValue)
  ) {
    specificOptions.unshift({ value: savedValue, label: savedValue });
  }

  return [...baseOptions, ...specificOptions]; // Combina a opção vazia com as específicas e a opção salva
};

export const getConsultantOptionsPlus = (): ConsultantOption[] => {
  let specificOptions: ConsultantOption[] = [];

  const allConsultants = [...Object.values(TechnicalConsultantPlus)];
  const uniqueConsultants = [...new Set(allConsultants)];

  uniqueConsultants.sort();

  specificOptions = uniqueConsultants.map((value) => ({
    value,
    label: value,
  }));

  return [...specificOptions]; // Combina a opção vazia com as específicas e a opção salva
};
